import React from "react";
import { useAuth } from "react-oidc-context";
import { toNString } from "../../../helpers/guids";

// NOTE: this is temporary until we get the confirmable modal working!

const PersonalMessageThreadControllerContext = React.createContext<{
    threadId: string | null
    setThread: (v: string | null) => void
    userId: string
} | null>(null);

export const usePersonalMessageThreadController = () => React.useContext(PersonalMessageThreadControllerContext);

export const PersonalMessageTreadControllerProvider = ({
    children
}: Readonly<{
    children: React.ReactNode
}>) => {
    const { user } = useAuth();
    const userId = toNString(user?.profile?.sub);
    const [threadId, setThreadId] = React.useState<string | null>(null);

    return (
        <PersonalMessageThreadControllerContext.Provider value={{
            threadId,
            setThread: (v: string | null) => setThreadId(() => v),
            userId
        }}>
            {children}
        </PersonalMessageThreadControllerContext.Provider>
    )
};